module.exports = __webpack_public_path__ + "img/pic_7.bbf01b5d.jpg";